import type { ReactNode } from 'react'

/** Inline advisory used to mark placeholder or unverified content. */
export function Notice({ children }: { children: ReactNode }) {
  return (
    <p
      role="note"
      className="flex gap-3 rounded-xl border border-gold/20 bg-gold/[0.05] px-4 py-3 text-sm text-muted"
    >
      <span aria-hidden="true" className="text-gold">
        ✦
      </span>
      <span>{children}</span>
    </p>
  )
}
